import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_network_error = _resolveComponent("network-error")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "My Cohort",
        "content-id": "cohort",
        "menu-id": "cohort-menu"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "cohort"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "8",
                sizeLg: "6",
                sizeXl: "6"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isReady)
                    ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.isNetworkError && _ctx.isReady)
                    ? (_openBlock(), _createBlock(_component_network_error, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_ctx.isReady && !_ctx.isNetworkError && _ctx.isTheUserAlone())
                    ? (_openBlock(), _createElementBlock("view", _hoisted_1, [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_subtitle, { class: "ion-text-center email-container" }, {
                              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" Looks like you are the only member of your group. If you want to create a group with your friends, please email the app admin at ", -1),
                                _createElementVNode("a", { href: "mailto:271emtiaj@gmail.com?subject=Cohort Creation!" }, "271emtiaj@gmail.com", -1),
                                _createTextVNode(" with the cohort's name and all members' emails. ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lottie_animation, {
                              class: "empty-cohort-icon",
                              "animation-data": _ctx.cohortWaitingAnimation,
                              loop: true
                            }, {
                              fallback: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("img", {
                                  src: "/assets/icon/diversity.svg",
                                  alt: "Cohort"
                                }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["animation-data"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isReady && !_ctx.isNetworkError && !_ctx.isTheUserAlone())
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        key: 3,
                        class: "margin-top-unset"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, { class: "display-flex ion-justify-content-center name-container" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.cohort.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isReady && !_ctx.isNetworkError && !_ctx.isTheUserAlone())
                    ? (_openBlock(), _createElementBlock("view", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cohort.users, (user) => {
                          return (_openBlock(), _createElementBlock("view", {
                            key: user.username
                          }, [
                            _createVNode(_component_ion_card, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_content, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_col, {
                                          sizeXs: "4",
                                          sizeSm: "4",
                                          sizeMd: "6",
                                          sizeLg: "6",
                                          sizeXl: "6",
                                          class: "avatar"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: 
                                                    user.profilePictureUrl ||
                                                    `https://gravatar.com/avatar/dba6bae8c566f9d4041fb9cd9ada7741?d=identicon&f=y`
                                                ,
                                              alt: `${user.name}'s avatar`,
                                              class: "rounded-circle ion-padding",
                                              width: "100"
                                            }, null, 8, _hoisted_3)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_col, {
                                          sizeXs: "8",
                                          sizeSm: "8",
                                          sizeMd: "6",
                                          sizeLg: "6",
                                          sizeXl: "6",
                                          class: "profile-info"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_card_subtitle, { class: "ion-text-capitalize" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(user.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(user.username), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128)),
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_subtitle, { class: "ion-text-center email-container" }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" Please ", -1),
                                _createElementVNode("a", { href: "mailto:271emtiaj@gmail.com?subject=Cohort Modification!" }, "email", -1),
                                _createTextVNode(" the app admin if you want to add new members or remove existing members with the cohort's name and all members' emails. ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}